// extracted by mini-css-extract-plugin
export default {"faqLabel":"mGOI51fx8b8fvr083ESI","fieldColumns":"CnM7caSPzUVDnCRTthCy","inputBox":"jxMSv34lj0qdqQxLZ49y"};